var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGridActive = function SvgGridActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.917 2.75c0-.506.41-.917.916-.917h6.417c.506 0 .917.41.917.917v6.417c0 .506-.41.916-.917.916h-6.417a.917.917 0 0 1-.916-.916V2.75ZM2.75 11.917a.917.917 0 0 0-.917.916v6.417c0 .506.41.917.917.917h6.417c.506 0 .916-.41.916-.917v-6.417a.917.917 0 0 0-.916-.916H2.75Zm10.083 0a.917.917 0 0 0-.916.916v6.417c0 .506.41.917.916.917h6.417c.506 0 .917-.41.917-.917v-6.417a.917.917 0 0 0-.917-.916h-6.417ZM2.75 1.833a.917.917 0 0 0-.917.917v6.417c0 .506.41.916.917.916h6.417c.506 0 .916-.41.916-.916V2.75a.917.917 0 0 0-.916-.917H2.75Z",
    clipRule: "evenodd"
  })));
};
export default SvgGridActive;